<template>
    <div class="order">
        <div style="margin-bottom:5px">
            <el-input
                v-model="query.serialNumber"
                placeholder="收货单号"
                class="handle-input mr10"
                size="small"
            ></el-input>
            <el-input
                v-model="query.expressCompany"
                placeholder="快递公司"
                class="handle-input mr10"
                size="small"
            ></el-input>
            <el-input
                v-model="query.expressNo"
                placeholder="快递单号"
                class="handle-input mr10"
                size="small"
            ></el-input>
            <el-button type="success" @click="searchHandle" size="small">查询</el-button>
            <el-button type="success" @click="clear" size="small">重置</el-button>
        </div>
        <div>
            <table>
                <thead>
                    <tr class="th">
                        <td>发货单号</td>
                        <td>收货人</td>
                        <td>联系方式</td>
                        <td width="200px">收货地址</td>
                        <td>快递公司</td>
                        <td>快递单号</td>
                        <td>创建时间</td>
                        <td>操作</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in orderList.records" :key="index" class="tr">
                        <td>{{ item.serialNumber }}</td>
                        <td>{{ item.receiveContact }}</td>
                        <td>{{ item.receivePhone }}</td>
                        <td>{{ item.province }}{{ item.city }}{{ item.area }}{{ item.address }}</td>
                        <td>{{ item.expressCompany }}</td>
                        <td>{{ item.expressNo }}</td>
                        <td>{{ item.createTime }}</td>
                        <td>
                            <el-button type="success" size="mini" @click="handleDetail(item)"
                                >商品明细</el-button
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
            <div
                class="table-empty"
                v-if="
                    !orderList ||
                        !orderList.records ||
                        (orderList.records && orderList.records.length === 0)
                "
            >
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next, total"
                :total="orderList.total"
                :page-size="orderList.size"
                :current-page="orderList.current"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>

        <el-dialog title="商品明细" :visible.sync="PdDialog" width="800px">
            <ProductDetail :product="product"></ProductDetail>
            <div slot="footer" class="dialog-footer"></div>
        </el-dialog>
    </div>
</template>

<script>
import * as apis from '../../fetch/order';

import ProductDetail from '../../components/order/ProductDetail';

export default {
    name: 'order',
    components: {
        ProductDetail,
    },
    data() {
        return {
            query: {
                serialNumber: '',
                expressCompany: '',
                expressNo: '',
            },
            formInline: {},
            orderList: [],
            PdDialog: false,
            product: [],
        };
    },
    methods: {
        clear() {
            this.query = {
                serialNumber: '',
                expressCompany: '',
                expressNo: '',
            };
        },
        getOrder(page = 1) {
            this.query.current = page;
            this.query.size = 20;
            this.query.expressType = 0;
            apis.shipPaging(this.query).then(res => {
                this.orderList = res.data;
            });
        },
        handleCurrentChange(page) {
            this.getOrder(page);
        },
        handleDetail(item) {
            this.PdDialog = true;
            this.product = item.expressOrderDetailVOList;
        },
        searchHandle() {
            this.getOrder();
        },
    },
    mounted() {
        this.getOrder();
    },
};
</script>

<style lang="less" scoped>
.handle-select {
    width: 150px;
    display: inline-block !important;
}

.handle-input {
    width: 140px;
    display: inline-block;
}
.mr10 {
    margin-right: 10px;
    margin-bottom: 10px;
}
</style>
